import { HStack } from '@lib/uikit';

import { Select } from './hooks/useVariantSelects';
import { VariantDropdownSelect } from './VariantDropdownSelect';
import { VariantRadioSelect } from './VariantRadioSelect';

interface VariantSelectsProps {
    selects: Select[];
    onSelectOption: (
        optionName: string,
        value?: string,
        isFinal?: boolean
    ) => void;
}

export const VariantSelects: React.FC<VariantSelectsProps> = ({
    selects,
    onSelectOption,
}) => {
    if (selects.length < 1) return null;

    return (
        <HStack
            spacing='md'
            rowSpacing='xs'
            flexWrap='wrap'
            justifyContent='flex-start'
        >
            {selects.map((select) => {
                if (
                    select.options.length > 5 ||
                    select.options.some(
                        (option) =>
                            (option.label ?? option.value).length > 10
                    )
                ) {
                    return (
                        <VariantDropdownSelect
                            key={select.name}
                            select={select}
                            onSelectOption={onSelectOption}
                        />
                    );
                } else {
                    return (
                        <VariantRadioSelect
                            key={select.name}
                            select={select}
                            onSelectOption={onSelectOption}
                        />
                    );
                }
            })}
        </HStack>
    );
};
